module.exports = __webpack_public_path__ + "media/images/cplook/mstile-144x144-00408ea4b7d9a328daa9b3d3c34aebfc.png";